/**
 * Coworking map.
 * @type {{attach: Drupal.behaviors.coworkingMap.attach}}
 */
const $ = window.jQuery;

export default {
  attach: function(context, settings) {
    const coworkingMap_once = once('coworking-map-once', '.paragraph.map .coworking-map', context);

    $(coworkingMap_once).each(function(i, mapElement) {
      // Set map element size on window resize.
      $(window).on('resize', function () {
        if ($(mapElement).width() < 550) {
          $(mapElement).css('height', $(mapElement).width());
        }
        else if ($(mapElement).width() < 1100) {
          $(mapElement).css('height', $(mapElement).width() / 8 * 6);
        }
        else {
          $(mapElement).css('height', $(mapElement).width() / 16 * 10);
        }
      });

      $(window).trigger('resize');

      // Init map.
      Drupal.behaviors.coworkingMap.mapInit(mapElement, settings);
    });
  },

  /**
   * Initializes the map.
   * @param mapElement
   * @param settings
   */
  mapInit: function(mapElement, settings) {
    let mapCenter = L.latLng(51.42, 7.8);
    let zoomLevel = Drupal.behaviors.coworkingMap.mapZoomLevel(mapElement);
    let map = L.map($(mapElement).attr('id'), {
      scrollWheelZoom: true,
      zoomControl: false,
      maxBounds: [[48.60, 5.52], [54.40, 9.62]],
      center: mapCenter,
      zoom: zoomLevel,
      minZoom: zoomLevel,
      maxZoom: 16
    });

    let imageUrl = '/themes/custom/urifm_theme/images/map-nrw.png';
    let imageBounds = [[48.09, 2.32], [54.63, 12.89]];

    let mapIcon = L.icon({
      iconUrl: '/themes/custom/urifm_theme/images/map-icon.png',
      iconSize: [23, 33],
      iconAnchor: [12, 32],
      popupAnchor: [0, -38],
    });

    let mapIconInactive = L.icon({
      iconUrl: '/themes/custom/urifm_theme/images/map-icon-inactive.png',
      iconSize: [23, 33],
      iconAnchor: [12, 32],
      popupAnchor: [0, -38],
    });

    // Add map tile.
    L.tileLayer('http://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="https://cartodb.com/attributions">CartoDB</a>'
    }).addTo(map);

    // Add image overlay.
    L.imageOverlay(imageUrl, imageBounds).addTo(map);

    // Add markers and tooltips to the map.
    const mapAddresses = settings.urifm_general.coworking_map[mapElement.id];

    if (mapAddresses) {
      mapAddresses.forEach(function(addressElement) {
        const popup = Drupal.behaviors.coworkingMap.mapPopup(addressElement.address);

        let marker;
        if (addressElement.address.inactive_location) {
          marker = L.marker([addressElement.lat, addressElement.lon], {icon: mapIconInactive});
        }
        else {
          marker = L.marker([addressElement.lat, addressElement.lon], {icon: mapIcon});
        }

        marker.bindPopup(popup, {autoClose: false, keepInView: false, autoPan: false, offset: new L.Point(0, 13)})
          .bindTooltip(addressElement.address.title, {permanent: false})
          .addTo(map);
      });

      // Observer for popups in mobile view, which triggers the link in popup on marker click.
      const $elementToObserve = $(mapElement).find(".leaflet-popup-pane");

      if ($elementToObserve[0]) {
        const observer = new MutationObserver(() => {
          if ($(mapElement).width() < 768) {
            if ($elementToObserve.find('.leaflet-popup-content .leaflet-popup-link a').length) {
              $elementToObserve.find('.leaflet-popup-content .leaflet-popup-link a')[0].click();
              $elementToObserve.empty();
            }
          }
        });
        observer.observe($elementToObserve[0], {subtree: true, childList: true});
      }
    }

    // Set popup position above or below the marker.
    map.on('popupopen', function(e) {
      let popup = $(mapElement).find('.leaflet-popup');

      popup.css('display', 'none');

      setTimeout(function() {
        let popup = $(mapElement).find('.leaflet-popup');
        let popupHeight = popup.height();

        if (e.popup._latlng.lat > 51.5) {
          // Set popup position above the marker.
          e.popup.options.offset = new L.Point(0, popupHeight + 52);
          $(mapElement).find('.leaflet-popup').addClass('leaflet-popup-bottom');
        }
        else {
          // Leave popup position below the marker.
          $(mapElement).find('.leaflet-popup').removeClass('leaflet-popup-bottom');
        }

        popup.css('display', 'block');
        $(mapElement).find('.leaflet-popup-bottom').css('display', 'flex');
        e.popup.update();
      }, 400);
    });

    // Set proper zoom levels and center the map on window resize.
    $(window).on('resize', function () {
      let zoomLevel = Drupal.behaviors.coworkingMap.mapZoomLevel(mapElement);

      map.setZoom(zoomLevel);
      map.setMinZoom(zoomLevel);
      map.flyTo(mapCenter);
    });
  },

  /**
   * Returns the map zoom level according to the map size.
   * @param mapElement
   */
  mapZoomLevel: function(mapElement) {
    let mapWidth = $(mapElement).width();
    let zoomLevel;

    if (mapWidth >= 910) {
      zoomLevel = 8;
    }
    else if (mapWidth >= 420) {
      zoomLevel = 7;
    }
    else {
      zoomLevel = 6;
    }

    return zoomLevel;
  },

  /**
   * Returns the marker popup from data.
   * @param data
   */
  mapPopup: function(data) {
    if (data) {
      let html = '';

      if (data.image_url) {
        html += '<div class="leaflet-popup-image"><img src="' + data.image_url + '" /></div>';
      }

      html += '<div class="leaflet-popup-information">';
        if (data.title) {
          html += '<div class="leaflet-popup-title"><h3>' + data.title + '</h3></div>';
        }

        html += '<div class="leaflet-popup-address">';
          if (data.address_line1) {
            html += data.address_line1 + '<br />';
          }
          if (data.address_line2) {
            html += data.address_line2 + '<br />';
          }
          if (data.postal_code && data.locality) {
            html += data.postal_code + ' ' + data.locality;
          }
        html += '</div>';

        if (data.description) {
          html += '<div class="leaflet-popup-description">' + data.description + '</div>';
        }

        if (data.link_url) {
          let linkTitle;
          if (data.link_title) {
            linkTitle = data.link_title;
          }
          else {
            linkTitle = Drupal.t('Show all location information.');
          }
          html += '<div class="leaflet-popup-link">';
          html += '<a href="' + data.link_url + '" title="' + linkTitle + '">' + Drupal.t('More info') + '</a>';
          html += '</div>';
        }
      html += '</div>';

      return html;
    }

    return '';
  },
}
